import * as Prompts from '../'
import { ControlTypes, BasePrompt } from '../../'

export class PromptFactory {
  public get(controlType: ControlTypes, options): BasePrompt<any> {
    const className = `${ControlTypes[controlType]}Prompt`
    const promptClass = Prompts[className]

    if (!promptClass) {
      throw new Error(`No prompt class found for ${ControlTypes[controlType]} control type. Expected ${className} to exist.`)
    }
    return new promptClass(options)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/prompt/prompt-factory/prompt.factory.ts